export const PREPEND_DAY = 'PREPEND_DAY'
export const APPEND_DAY = 'APPEND_DAY'
export const REMOVE_DAY = 'REMOVE_DAY'
export const UPDATE_ARRIVAL_DATE = 'UPDATE_ARRIVAL_DATE'
export const UPDATE_DEPARTURE_DATE = 'UPDATE_DEPARTURE_DATE'
export const UPDATE_TOTAL_DAYS = 'UPDATE_TOTAL_DAYS'
export const UPDATE_TRIP_TITLE = 'UPDATE_TRIP_TITLE'
export const UPDATE_ITIN_NAME = 'UPDATE_ITIN_NAME'
export const UPDATE_DESTINATION = 'UPDATE_DESTINATION'
export const UPDATE_ACCOMMODATION = 'UPDATE_ACCOMMODATION'
export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR'
export const TOGGLE_BOOKING = 'TOGGLE_BOOKING'
export const UPDATE_ORIGIN = 'UPDATE_ORIGIN'
export const UPDATE_RETURN = 'UPDATE_RETURN'
export const UPDATE_ORIGIN_TO_RETURN = 'UPDATE_ORIGIN_TO_RETURN'
export const UPDATE_RETURN_TO_ORIGIN = 'UPDATE_RETURN_TO_ORIGIN'
export const ADD_TRANSPORTATION = 'ADD_TRANSPORTATION'
export const REMOVE_TRANSPORTATION = 'REMOVE_TRANSPORTATION'
export const ADD_TRAVELERS = 'ADD_TRAVELERS'
export const UPDATE_TRANSPORTATION_RESERVATION = 'UPDATE_TRANSPORTATION_RESERVATION'

export function prependDay() {
    return {
        type: PREPEND_DAY,
    }
}

export function appendDay() {
    return {
        type: APPEND_DAY,
    }
}

export function removeDay(index) {
    return {
        type: REMOVE_DAY,
        index
    }
}

export function updateArrivalDate(date) {
    return {
        type: UPDATE_ARRIVAL_DATE,
        date
    }
}

export function updateDepartureDate(date) {
    return {
        type: UPDATE_DEPARTURE_DATE,
        date
    }
}

export function updateTotalDays(tripLength) {
    return {
        type: UPDATE_TOTAL_DAYS,
        tripLength
    }
}

export function updateDestination(leg, destination) {
    return {
        type: UPDATE_DESTINATION,
        leg,
        destination
    }
}

export function updateAccommodation(leg, destination, accommodation) {
    return {
        type: UPDATE_ACCOMMODATION,
        leg,
        destination,
        accommodation
    }
}

export function updateTripTitle(tripName) {
    return {
        type: UPDATE_TRIP_TITLE,
        tripName
    }
}

export function updateItinName(itinName) {
    return {
        type: UPDATE_ITIN_NAME,
        itinName
    }
}

export function toggleSidebar() {
    return {
        type: TOGGLE_SIDEBAR,
    }
}

export function toggleBooking() {
    return {
        type: TOGGLE_BOOKING,
    }
}

export function updateOrigin(location) {
    return {
        type: UPDATE_ORIGIN,
        location
    }
}

export function updateReturn(location) {
    return {
        type: UPDATE_RETURN,
        location
    }
}

export function updateReturnToOrigin(location) {
    return {
        type: UPDATE_RETURN_TO_ORIGIN,
        location
    }
}

export function updateOriginToReturn(location) {
    return {
        type: UPDATE_ORIGIN_TO_RETURN,
        location
    }
}

export function onAddTransportation(depLeg, arrLeg, depCity, arrCity, transportation, user) {
    return {
        type: ADD_TRANSPORTATION,
        depLeg,
        arrLeg,
        depCity,
        arrCity,
        transportation,
        user
    }
}

export function onRemoveTransportation(transportation) {
    return {
        type: REMOVE_TRANSPORTATION,
        transportation
    }
}

export function addTravelers(travelers) {
    return {
        type: ADD_TRAVELERS,
        travelers
    }
}
export function onUpdateTransportationReservation(depLeg, arrLeg, depCity, arrCity, transportation) {
    return {
        type: UPDATE_TRANSPORTATION_RESERVATION,
        depLeg, 
        arrLeg, 
        depCity, 
        arrCity, 
        transportation  
    }
}